import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useGetLoggedUser } from "../../shared/hooks/useUser";

const ProtectedRoute = ({ children }) => {
    const { data: loggedUser, status } = useGetLoggedUser(true);

    const [loggedIn, setLoggedIn] = useState();

    useEffect(() => {
        // Important: handle the "logged out" case too (loggedUser can be undefined)
        if (status === "error") {
            setLoggedIn(false);
            return;
        }

        if (status === "success") {
            if (!loggedUser) {
                setLoggedIn(false);
                return;
            }
            if (loggedUser.user_type && loggedUser.user_type !== "Website User") {
                setLoggedIn(true);
            } else {
                setLoggedIn(false);
            }
        }
    }, [loggedUser, status]);

    if (loggedIn == false) {
        return <Navigate to={"/login"} replace />;
    }
    return children;
};

export default ProtectedRoute;
